import { formatarDataHora } from "../../../utils/solicitacoes/formatters";

const ICONES = {
    CRIACAO: "fa fa-plus-circle text-primary",
    MUDANCA_ETAPA: "fa fa-arrow-right text-primary",
    MUDANCA_RESPONSAVEL: "fa fa-user-check text-primary",
    APROVACAO: "fa fa-check-circle text-success",
    REPROVACAO: "fa fa-times-circle text-destructive",
    RETIFICACAO: "fa fa-undo text-amber-600",
    CONCLUSAO: "fa fa-flag-checkered text-success",
    NOTIFICACAO: "fa fa-bell text-primary",
    EDICAO: "fa fa-pencil-alt text-primary",
    COMENTARIO: "fa fa-comment text-primary",
    ANEXO: "fa fa-paperclip text-primary",
    CANCELAMENTO: "fa fa-ban text-destructive",
    ELIMINACAO: "fa fa-trash text-destructive",
};

const TITULOS = {
    CRIACAO: "Criação",
    ANEXO: "Anexo",
    MUDANCA_ETAPA: "Mudança de etapa",
    MUDANCA_RESPONSAVEL: "Mudança de responsável",
    APROVACAO: "Aprovação",
    REPROVACAO: "Reprovação",
    RETIFICACAO: "Retificação",
    CONCLUSAO: "Conclusão",
    NOTIFICACAO: "Notificação",
    EDICAO: "Edição",
    CANCELAMENTO: "Cancelamento",
    ELIMINACAO: "Eliminação",
};

function iconePara(item) {
    if (item.tipo === "COMENTARIO") return ICONES.COMENTARIO;
    if (item.tipo === "ANEXO") return ICONES.ANEXO;
    return ICONES[item.titulo] || "fa fa-circle text-muted-foreground";
}

function tituloAmigavel(item) {
    if (item.tipo === "COMENTARIO") return "Comentário";
    if (item.tipo === "ANEXO") return "Anexo";
    return TITULOS[item.titulo] || item.titulo;
}

export default function Timeline({ itens = [], loading = false }) {
    if (loading) {
        return (
            <div className="space-y-4 animate-pulse">
                {[1, 2, 3].map(i => (
                    <div key={i} className="flex gap-3">
                        <div className="w-6 h-6 rounded-full bg-muted shrink-0" />
                        <div className="flex-1 space-y-1.5 pt-0.5">
                            <div className="h-3 bg-muted rounded w-1/3" />
                            <div className="h-3 bg-muted rounded w-2/3" />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (itens.length === 0) {
        return <p className="text-sm text-muted-foreground text-center py-6">Nenhum evento registrado ainda.</p>;
    }

    const ordenado = [...itens].sort((a, b) => new Date(a.dataHora) - new Date(b.dataHora));

    return (
        <ol className="relative border-s-2 border-border ms-2">
            {ordenado.map((item, idx) => (
                <li key={idx} className="mb-5 ms-5 last:mb-0">
                    <span className="absolute -start-[9px] flex items-center justify-center w-4 h-4 bg-card rounded-full ring-4 ring-card border border-border">
                        <i className={`${iconePara(item)} text-[9px]`} />
                    </span>
                    <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-sm font-semibold text-foreground">{tituloAmigavel(item)}</span>
                        <span className="text-[11px] text-muted-foreground">{formatarDataHora(item.dataHora)}</span>
                    </div>
                    <p className="text-xs text-muted-foreground">{item.usuarioNome}</p>
                    {item.conteudo && <p className="text-sm text-foreground mt-1 break-words">{item.conteudo}</p>}
                </li>
            ))}
        </ol>
    );
}
